"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VelvetSDK = void 0;
var cmsService_1 = require("../services/cms/cmsService");
var config_1 = require("../services/config/config");
var userManagement_1 = require("../services/userManagement/userManagement");
var vocabulary_1 = require("../services/vocabulary/vocabulary");
var resumeWatchingService_1 = require("../services/resumeWatching/resumeWatchingService");
var tokenManager_1 = require("../services/userManagement/token/velvet/tokenManager");
var themeManager_1 = require("../services/theme/themeManager");
var resumeWatchingStorageRepository_1 = require("../services/storage/resumeWatching/resumeWatchingStorageRepository");
var myListManager_1 = require("../services/storage/myList/myListManager");
var languageManager_1 = require("../services/storage/language/languageManager");
var profilesManager_1 = require("../services/storage/profiles/profilesManager");
var VelvetSDK = /** @class */ (function () {
    function VelvetSDK() {
    }
    VelvetSDK.configure = function (appConfig) {
        this.appConfig = appConfig;
        this.playerVendor = appConfig.services.video_player.vendor_name;
    };
    VelvetSDK.configurePlayer = function (playerConfig, videoInfo, profileId) {
        this.playerConfig = playerConfig;
        this.videoInfo = videoInfo;
        this.profileId = profileId;
    };
    VelvetSDK.Configuration = {
        configuration: {},
        get service() {
            var instance = new config_1.ConfigService();
            return instance;
        },
    };
    VelvetSDK.Vocabulary = {
        vocabulary: {},
        isVocabFetching: true,
        get service() {
            var instance = new vocabulary_1.GenericVocabularyService();
            return instance;
        },
    };
    VelvetSDK.Authentication = {
        get service() {
            var instance = new userManagement_1.UserManagement();
            return instance;
        },
    };
    VelvetSDK.TokenManager = {
        get service() {
            var instance = new tokenManager_1.TokenManager();
            return instance;
        },
    };
    VelvetSDK.CMS = {
        isMenuFetching: true,
        service: function (networkService) {
            var cms = new cmsService_1.CMSService(networkService);
            return cms;
        },
    };
    VelvetSDK.ResumeWatching = {
        get service() {
            var instance = new resumeWatchingService_1.ResumeWatchingService(VelvetSDK.videoInfo, new resumeWatchingStorageRepository_1.ResumeWatchingStorageRepository(), VelvetSDK.profileId);
            return instance;
        },
    };
    VelvetSDK.Storage = {
        ResumeWatching: {
            get service() {
                var instance = new resumeWatchingStorageRepository_1.ResumeWatchingStorageRepository();
                return instance;
            },
        },
        Favorites: {
            get service() {
                var instance = new myListManager_1.FavoritesManager();
                return instance;
            },
        },
        Language: {
            get service() {
                var instance = new languageManager_1.LanguageManager();
                return instance;
            },
        },
        Profiles: {
            get service() {
                var instance = new profilesManager_1.ProfilesManager();
                return instance;
            },
        },
    };
    VelvetSDK.Theme = {
        get service() {
            var instance = new themeManager_1.ThemeManager();
            return instance;
        },
    };
    VelvetSDK.Player = {
        get service() {
            var playerVendor = VelvetSDK.appConfig.services.video_player.vendor_name;
            return Promise.resolve()
                .then(function () { return Promise.resolve().then(function () { return __importStar(require("../services/videoPlayer/".concat(playerVendor, "/videoPlayer"))); }); })
                .then(function (_a) {
                var GenericVideoPlayer = _a.GenericVideoPlayer;
                var player = new GenericVideoPlayer(VelvetSDK.playerConfig, VelvetSDK.appConfig.services, VelvetSDK.videoInfo, VelvetSDK.profileId);
                return player;
            });
        },
    };
    VelvetSDK.Analytics = {
        get service() {
            var playerVendor = VelvetSDK.appConfig.services.video_player.vendor_name;
            return Promise.resolve()
                .then(function () { return Promise.resolve().then(function () { return __importStar(require("../services/videoPlayer/".concat(playerVendor, "/videoAnalyticsManager"))); }); })
                .then(function (_a) {
                var VideoAnalyticsManager = _a.VideoAnalyticsManager;
                var analytics = new VideoAnalyticsManager(VelvetSDK.appConfig.services.video_analytics);
                return analytics;
            });
        },
    };
    return VelvetSDK;
}());
exports.VelvetSDK = VelvetSDK;
